import { useTranslation } from 'react-i18next';
import { Button, Input } from '@web/utils/src';
import { AddressValidationInput } from '@/components/AddressValidationInput';

interface AddAddressProps {
  inputHandler: (name: string, value: string | number) => void;
  form: {
    addressLine1: string;
    addressLine2: string;
    addressPostcode: string;
    addressLocality: string;
  };
  setCoordinates: (coordinates: { lat: number; long: number }) => void;
  submitHandler: () => void;
  isEdit?: string | null;
}

const ProfileAddressForm: React.FC<AddAddressProps> = (props) => {
  const { inputHandler, form, setCoordinates, submitHandler } = props;
  const { t } = useTranslation();

  return (
    <div className="p-2-0 bg-primary-white rounded-8-0">
      <div className="pb-2-0">
        <AddressValidationInput
          setValue={inputHandler}
          setCoordinates={setCoordinates}
        />
      </div>
      <div className="flex flex-col gap-1-0">
        <Input
          id="addressLine1"
          label={t('profile.address_line1') || ''}
          value={form.addressLine1}
          onChange={inputHandler}
        />
        <Input
          id="addressLine2"
          label={t('profile.address_line2') || ''}
          value={form.addressLine2}
          onChange={inputHandler}
        />
        <Input
          id="addressLocality"
          label={t('profile.address_locality') || ''}
          value={form.addressLocality}
          onChange={inputHandler}
        />
        <Input
          id="addressPostcode"
          label={t('profile.address_postcode') || ''}
          onChange={inputHandler}
          value={form.addressPostcode}
        />
      </div>
      <div>
        <Button
          variant="secondary"
          className="mt-1-0 ml-auto block"
          onClick={submitHandler}
        >
          {t('global.submit')}
        </Button>
      </div>
    </div>
  );
};

export default ProfileAddressForm;
